import {rawRenderingLib} from '@wallaby-ui/core';
import styles from 'src/js/common/components/formatters/LinkFormatter.less';
import baseLinkFormatterParams from 'src/js/lib/raw_rendering/base_link_formatter_params';

import documentLinkRenderer from './document_link_renderer';

/**
 * Returns raw DOM element version of LinkFormatter component.
 * @param params
 * @param services
 * @returns {Element|String}
 */
export default function linkFormatter(params, services = {}) {
  const {linkId, newSearchParams, route, titleText, translatedValue, value} = baseLinkFormatterParams(params, services);
  let divElem;
  if (value) {
    divElem = document.createElement('div');
    divElem.className = styles.dlLinkFormatter;
    const textElem = rawRenderingLib.plainTextOrHtmlRenderer({
      showHtml: true,
      text: translatedValue,
      className: styles.dlLinkFormatterText,
    });
    const documentLinkElem = documentLinkRenderer(
      {
        docId: linkId,
        documentDetailRoute: route,
        titleText,
        searchParams: newSearchParams,
        suppressPadding: true,
        children: textElem,
      },
      services
    );
    rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(divElem, documentLinkElem);
  } else {
    divElem = '';
  }

  return divElem;
}
